import React from 'react';
import classNames from 'classnames/bind';
import styles from './Beneficios.module.scss';
import CDNImage from '../../utils/CDNImage';

let cx = classNames.bind(styles);

const Diversidad = () => {
	return (
		<section
			id='beneficios'
			className={cx({ beneficios: true, 'mt-10 py-10 pb-4': true })}
		>
			<div className='container mx-auto flex flex-col justify-start items-center'>
				<h1 className='text-white font-Avenir-Heavy text-5xl py-4'>
					<strong className='font-Avenir-Black'>BENEFICIOS</strong>
				</h1>
				<p className='text-white text-2xl font-bold text-center px-4 lg:px-48 pb-20 font-Avenir-Black'>
					En Ideal queremos Alimentar tus momentos de vida, por eso nuestros
					beneficios se orientan a cada uno de estos instantes.
				</p>
			</div>
			<div className='container mx-auto w-full flex flex-col'>
				<div className='flex flex-col lg:flex-row p-8 lg:p-0'>
					<div
						className={cx({
							beneficios_box: true,
							'flex flex-col w-full lg:w-1/4 justify-center mb-12 lg:mb-0 lg:mx-4 border-tcn-dark-blue bg-white': true,
						})}
					>
						<CDNImage
							className={cx({ beneficios_img_1: true, 'self-center': true })}
							image_name={'ideal_elementos-76.png'}
							alt='ideal_elementos-79'
						/>
						<p
							className={cx({
								text: true,
								'self-start px-3 text-tcn-dark-blue font-bold font-Avenir-Black': true,
							})}
						>
							Queremos que hornees tu talento con nosotros, que alcances
							resultados, que te desafíes constantemente y que seas reconocido y retribuido por tus logros
						</p>
						<p
							className={cx({
								hover: true,
								'self-start px-3 text-tcn-dark-blue font-bold font-Avenir-Black': true,
							})}
						>
							- Bono por Resultados <br />
							- Desarrollo de Carrera y Aprendizaje constante <br />- GB
							University
						</p>
					</div>
					<div
						className={cx({
							beneficios_box: true,
							'flex flex-col w-full lg:w-1/4 justify-center my-12 lg:my-0 mx-0 lg:mx-4 border-white bg-tcn-light-blue': true,
						})}
					>
						<CDNImage
							className={cx({ beneficios_img_2: true, 'self-center': true })}
							image_name={'ideal_elementos-77.png'}
							alt='ideal_elementos-79'
						/>
						<p
							className={cx({
								text: true,
								'self-start px-3 text-white font-bold font-Avenir-Black': true,
							})}
						>
							Queremos cuidarte a ti y tu familia para que te sientes seguro(a)
							y respaldado(a) en la mayoría de momentos.
						</p>
						<p
							className={cx({
								hover: true,
								'self-start px-3 text-white font-bold font-Avenir-Black': true,
							})}
						>
							- Subsidio por licencia <br />
							- Seguro complementario costo libre para el colaborador y sus
							cargas directas. <br />- Seguro de Vida
						</p>
					</div>
					<div
						className={cx({
							beneficios_box: true,
							'flex flex-col w-full lg:w-1/4 justify-center my-12 lg:my-0 mx-0 lg:mx-4 border-tcn-red bg-white': true,
						})}
					>
						<CDNImage
							className={cx({ beneficios_img_3: true, 'self-center': true })}
							image_name={'ideal_elementos-78.png'}
							alt='ideal_elementos-79'
						/>
						<p
							className={cx({
								text: true,
								'self-start px-3 text-tcn-red font-bold font-Avenir-Black': true,
							})}
						>
							Estamos para acompañarte en diferentes instantes de tu vida, siéntete como en casa.
						</p>
						<p
							className={cx({
								hover: true,
								'self-start px-3 text-tcn-red font-bold font-Avenir-Black': true,
							})}
						>
							- Bono por nacimiento de hijo y/o adopción <br/>
							- Bono por matrimonio <br/>
							- Gift Card Fiestas Patrias y navidad <br/>
							- Bono Escolaridad <br/>
							- Bono de Vacaciones <br/>
						</p>
					</div>
					<div
						className={cx({
							beneficios_box: true,
							'flex flex-col w-full lg:w-1/4 justify-center mt-12 lg:mt-0 mx-0 lg:mx-4 border-tcn-cyan bg-white': true,
						})}
					>
						<CDNImage
							className={cx({ beneficios_img_4: true, 'self-center': true })}
							image_name={'ideal_elementos-79.png'}
							alt='ideal_elementos-79'
						/>
						<p
							className={cx({
								text: true,
								'self-start px-3 text-tcn-dark-blue font-bold font-Avenir-Black': true,
							})}
						>
						Sabemos que tu tiempo es  valioso, queremos que lo disfrutes.
						</p>
						<p
							className={cx({
								hover: true,
								'self-start px-3 text-tcn-dark-blue font-bold font-Avenir-Black': true,
							})}
						>
							- Viernes corto <br />
						</p>
					</div>
				</div>
			</div>
			<div className='container mx-auto w-full flex flex-col justify-end items-end p-4 lg:p-0 pt-2 lg:pt-20'>
				<div className='flex flex-col w-full lg:w-3/4 items-end justify-center'>
					<span className='text-white text-base font-Avenir-Black mx'>
						<strong className='font-Avenir-Black'>*Consideraciones: </strong>{' '}
						Depende del cargo <br /> y del tipo de contrato.
					</span>
				</div>
			</div>
		</section>
	);
};

export default Diversidad;
